<template>
    <n-menu v-model:value="activeKey" mode="horizontal" :options="optionsToBeRendered" />
</template>

<script>
import { defineComponent, h, ref } from "vue";
import { RouterLink } from 'vue-router'
import { mapState } from 'pinia';
import authStore from "../store/auth"

let userShouldSee = ['plans'];
let adminShouldSee = ['dashboard-admin', 'providers', 'products', 'supplies', 'seeds'];

export default {
    name: 'NavBar',
    data() {
        return {
            activeKey: ref(null),
            menuOptions: [
                // { key: 'home', label: () => h(RouterLink, { to: '/' }, 'Inicio') },
                { key: 'dashboard-admin', label: () => h(RouterLink, { to: '/app/dashboard/admin' }, 'Inicio') }, // ADMIN DASHBOARD
                // { key: 'dashboard-user', label: () => h(RouterLink, { to: '/app/dashboard/user' }, 'Inicio') },
                { key: 'plans', label: () => h(RouterLink, { to: '/app/plans/list' }, 'Planes') },
                { key: 'providers', label: () => h(RouterLink, { to: '/app/providers/list' }, 'Proveedores') },
                { key: 'products', label: () => h(RouterLink, { to: '/app/products/list' }, 'Productos') },
                { key: 'seeds', label: () => h(RouterLink, { to: '/app/supplies/seed/list' }, 'Semillas') },
                {
                    label: 'Suministros',
                    key: 'supplies',
                    children: [
                        {
                            label: () => h(RouterLink, { to: '/app/supplies/additives/list' }, 'Aditivos'),
                            key: 'aditivos',
                        },
                        {
                            label: () => h(RouterLink, { to: '/app/supplies/fertilizer/list' }, 'Fertilizantes'),
                            key: 'fertilizantes',
                        },
                        {
                            label: () => h(RouterLink, { to: '/app/supplies/fertilizerAndPhytosanitary/list' }, 'Fertilizantes + Fitosanitarios'),
                            key: 'fertilizantesAndPhytosanitary',
                        },
                        {
                            label: () => h(RouterLink, { to: '/app/supplies/phytosanitary/list' }, 'Fitosanitarios'),
                            key: 'fitosanitarios',

                        },
                        {
                            label: () => h(RouterLink, { to: '/app/supplies/gasoil/list' }, 'Gasoil'),
                            key: 'gasoil',
                        },
                    ]
                },
                //Dropdown menu for providers:
                // {
                //     key: 'providers-options',
                //     label: 'Proveedores',
                //     children: [
                //         {
                //             type: 'group',
                //             label: 'Opciones de proveedor:',
                //             key: 'providers-options-list',
                //             children: [
                //                 {
                //                     label: () => h(RouterLink, { to: '/create-provider' }, 'Crear proveedor'),
                //                     key: 'create-provider'
                //                 }, {
                //                     label: () => h(RouterLink, { to: '/my-providers' }, 'Ver proveedores'),
                //                     key: 'see-providers'
                //                 }
                //             ]
                //         }
                //     ]
                // },
            ],
            optionsToBeRendered: []
        }
    },
    computed: {
        ...mapState(authStore, ['isAdmin', "adminIsLoggedInAsBasicUser", 'user']),
    },
    watch: {
        user(newUser, oldUser) {
            if (newUser.role !== oldUser.role) {
                this.renderNavBarItems();
            }
        }
    },
    methods: {
        renderNavBarItems() {
            let optionsArray = [];
            if (this.isAdmin) {
                for (let option of this.menuOptions) {
                    for (let adminOption of adminShouldSee) {
                        if (adminOption === option.key) {
                            optionsArray.push(option)
                        }
                    }
                }
                // if is mobile
                // let hamburguerMenu = {label: opciones, children: everything[]}
            } else {
                for (let option of this.menuOptions) {
                    for (let userOption of userShouldSee) {
                        if (userOption === option.key) {
                            optionsArray.push(option)
                        }
                    }
                }
            }
            this.optionsToBeRendered = [...optionsArray]
        }
    },
    mounted() {
        //Avoid rendering navbar items that they shouldn't be able to see
        this.renderNavBarItems();
    }
};
</script>